import { useState, useEffect } from "react";
import styles from "./styles.module.css";
import toast from "react-hot-toast";
import { KEYBOARD_KEYS } from "const";
import { roundOff } from "helpers/NumberFormatHelper";
import ButtonRed from "components/utils/CustomFields/ButtonRed";
import ButtonGray from "components/utils/CustomFields/ButtonGray";

export default function EditSaleDescriptionDialog({ open, onClose, onConfirm, sale }) {
  const [description, setDescription] = useState("");

  useEffect(() => {
    if (open) {
      setDescription("");
    }
  }, [open]);

  if (!open) return null;

  const handleConfirm = () => {
    const trimmed = description.trim();
    if (!trimmed) {
      toast.error("Please enter a description for the bill reduction");
      return;
    }
    onConfirm(trimmed);
  };

  const handleKeyDown = (e) => {
    if (e.key === KEYBOARD_KEYS.ENTER && (e.ctrlKey || e.metaKey)) {
      e.preventDefault();
      handleConfirm();
    } else if (e.key === KEYBOARD_KEYS.ESCAPE) {
      e.preventDefault();
      onClose();
    }
  };

  const difference = Math.max(Number(sale?.previous_payable || 0) - Number(sale?.payable || 0), 0);

  return (
    <div
      className={styles.popUp}
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <div className={styles.modalContent}>
        <h3 className={styles.title}>Reason for Bill Reduction</h3>

        {/* Amount summary card */}
        <div className={styles.summaryCard}>
          <div className={styles.summaryItem}>
            <span className={styles.summaryLabel}>Previous Payable</span>
            <span className={styles.summaryValue}>{roundOff(sale?.previous_payable || 0)}</span>
          </div>

          <div className={styles.summaryItemCenter}>
            <span className={styles.summaryLabel}>New Payable</span>
            <span className={styles.summaryValueNew}>{roundOff(sale?.payable || 0)}</span>
          </div>

          <div className={styles.summaryItemRight}>
            <span className={styles.summaryLabelError}>Reduced By</span>
            <span className={styles.summaryValueError}>{roundOff(difference)}</span>
          </div>
        </div>

        <div>
          <div className={styles.fieldLabel}>Please enter the description / reason for reducing the bill amount:</div>
          <textarea
            autoFocus
            rows={4}
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            onKeyDown={handleKeyDown}
            className={styles.textarea}
          />
        </div>

        <div className={styles.footerBtns}>
          <ButtonGray onClick={onClose}>Cancel</ButtonGray>
          <ButtonRed onClick={handleConfirm}>Confirm & Proceed</ButtonRed>
        </div>
      </div>
    </div>
  );
}
